// import React, { useEffect, useState } from 'react';
// import emptyCartImg from "../images/EmptyCart.png";
// import { MdDelete } from "react-icons/md";
// import { Link, useNavigate } from 'react-router-dom';
// import { IoBagCheckSharp } from "react-icons/io5";
// import { useDispatch, useSelector } from 'react-redux';
// import { getUserCart, syncLocalCart } from '../features/user/userSlice';
// import { base_url } from '../utils/axiosConfig';
// import axios from 'axios';
// import { IconButton } from '@mui/material';
// import AddIcon from '@mui/icons-material/Add';
// import RemoveIcon from '@mui/icons-material/Remove';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { LuShoppingCart } from "react-icons/lu";
// import toast, { Toaster } from 'react-hot-toast';

// const Cart = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { cartProducts, isAuthenticated } = useSelector(state => state.auth);
//   const [cartItems, setCartItems] = useState([]);

//   useEffect(() => {
//     if (isAuthenticated) {
//       dispatch(getUserCart());
//     } else {
//       const savedCart = JSON.parse(localStorage.getItem('cart')) || [];
//       setCartItems(savedCart);
//       dispatch(syncLocalCart(savedCart));
//     }
//   }, [dispatch, isAuthenticated]);

//   useEffect(() => {
//     if (isAuthenticated && cartProducts?.length > 0) {
//       const updatedCart = cartProducts.map(item => ({
//         ...item,
//         quantity: item.quantity || 1,
//       }));
//       setCartItems(updatedCart);
//     } else {
//       const savedCart = JSON.parse(localStorage.getItem('cart')) || [];
//       const updatedSavedCart = savedCart.map(item => ({
//         ...item,
//         quantity: item.quantity || 1,
//       }));
//       setCartItems(updatedSavedCart);
//     }
//   }, [cartProducts, isAuthenticated]);

//   const getPrice = (item) => {
//   const product = item?.ProductId;
//   if (!product) return 0;

//   if (!isAuthenticated) {
//     return product.offerPrice && product.offerPrice > 0
//       ? product.offerPrice
//       : product.originalPrice || item.price || 0;
//   }

//   return product.offerPrice && product.offerPrice > 0
//     ? product.offerPrice
//     : product.CurrentPrice || 0;
// };

// const getOriginalPrice = (item) => {
//   const product = item?.ProductId;
//   if (!product) return 0;

//   if (!isAuthenticated) {
//     return product.originalPrice || item.price || 0;
//   }

//   return product.CurrentPrice || product.offerPrice || 0;
// };

// const getGstPercent = (item) => {
//   const product = item?.ProductId;
//   if (!product) return 0;

//   return parseFloat(product.gst || '0');
// };


//   const increaseQuantity = async (cartItemId) => {
//     const cartItem = cartItems.find(item => item.ProductId._id === cartItemId);
//     if (!cartItem) return;

//     const newQuantity = cartItem.quantity + 1;

//     if (isAuthenticated) {
//       try {
//         const token = JSON.parse(localStorage.getItem('customer'))?.token;
//         const config = {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//           },
//         };

//         await axios.put(`${base_url}user/updatecart`, {
//           ProductId: cartItemId,
//           quantity: newQuantity,
//           price: getPrice(cartItem),
//         }, config);

//         const updatedCart = cartItems.map(item =>
//           item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
//         );
//         setCartItems(updatedCart);
//         toast.success('Quantity increased!');
//         dispatch(getUserCart());
//       } catch (error) {
//         toast.error(error.response?.data?.message || 'Failed to increase quantity.');
//       }
//     } else {
//       const updatedCart = cartItems.map(item =>
//         item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
//       );
//       setCartItems(updatedCart);
//       localStorage.setItem('cart', JSON.stringify(updatedCart));
//       dispatch(syncLocalCart(updatedCart));
//       toast.success('Quantity increased (local)!');
//     }
//   };

//   const decreaseQuantity = async (cartItemId) => {
//     const cartItem = cartItems.find(item => item.ProductId._id === cartItemId);
//     if (!cartItem) return;

//     const newQuantity = Math.max(1, cartItem.quantity - 1);

//     if (isAuthenticated) {
//       try {
//         const token = JSON.parse(localStorage.getItem('customer'))?.token;
//         const config = {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//           },
//         };

//         await axios.put(`${base_url}user/updatecart`, {
//           ProductId: cartItemId,
//           quantity: newQuantity,
//           price: getPrice(cartItem),
//         }, config);

//         const updatedCart = cartItems.map(item =>
//           item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
//         );
//         setCartItems(updatedCart);
//         toast.success('Quantity decreased!');
//         dispatch(getUserCart());
//       } catch (error) {
//         toast.error(error.response?.data?.message || 'Failed to decrease quantity.');
//       }
//     } else {
//       const updatedCart = cartItems.map(item =>
//         item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
//       );
//       setCartItems(updatedCart);
//       localStorage.setItem('cart', JSON.stringify(updatedCart));
//       dispatch(syncLocalCart(updatedCart));
//       toast.success('Quantity decreased (local)!');
//     }
//   };

//   const handleRemoveItem = async (cartItemId) => {
//     if (isAuthenticated) {
//       try {
//         const token = JSON.parse(localStorage.getItem('customer'))?.token;
//         const config = {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             Accept: 'application/json',
//             'Content-Type': 'application/json',
//           },
//         };

//         await axios.delete(`${base_url}user/delete-product-cart`, {
//           ...config,
//           data: { cartItemId },
//         });

//         const updatedCart = cartItems.filter(item => item._id !== cartItemId);
//         setCartItems(updatedCart);
//         toast.success('Item removed!');
//         dispatch(getUserCart());
//       } catch (error) {
//         toast.error('Error removing item.');
//       }
//     } else {
//       const updatedCart = cartItems.filter(item => item._id !== cartItemId);
//       setCartItems(updatedCart);
//       localStorage.setItem('cart', JSON.stringify(updatedCart));
//       dispatch(syncLocalCart(updatedCart));
//       toast.success('Item removed from local cart!');
//     }
//   };

//   const calculateSubTotal = () => {
//     return cartItems
//       .reduce((acc, item) => {
//         const price = getPrice(item);
//         const gstPercent = getGstPercent(item);
//         const gstAmount = (price * item.quantity * gstPercent) / 100;
//         return acc + price * item.quantity + gstAmount;
//       }, 0)
//       .toFixed(2);
//   };

//   const calculateCartTotal = () => {
//     return cartItems
//       .reduce((acc, item) => {
//         const price = getPrice(item);
//         return acc + price * item.quantity;
//       }, 0)
//       .toFixed(2);
//   };

//   const calculateOriginalTotal = () => {
//     return cartItems
//       .reduce((acc, item) => {
//         const origPrice = getOriginalPrice(item);
//         return acc + origPrice * item.quantity;
//       }, 0)
//       .toFixed(2);
//   };

//   const calculateDiscount = () => {
//     const origTotal = parseFloat(calculateOriginalTotal());
//     const cartTotal = parseFloat(calculateCartTotal());
//     return (origTotal - cartTotal).toFixed(2);
//   };

//   const calculateSavings = () => {
//     const origTotal = parseFloat(calculateOriginalTotal());
//     const subtotal = parseFloat(calculateSubTotal());
//     const discount = parseFloat(calculateDiscount());
//     return (origTotal - subtotal + discount).toFixed(2); // Adjusted to account for GST in savings
//   };

//   // const platformFee = 5;

//   return (
//     <section className="cart-wrapper py-4">
//       <Toaster position="top-center" reverseOrder={false} />
//       <div className="container-xxl px-3">
//         {cartItems.length === 0 ? (
//           <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75vh' }}>
//             <img
//               src={emptyCartImg}
//               alt="Empty Cart"
//               style={{ width: '120px', height: '120px', objectFit: 'contain', marginBottom: '16px' }}
//             />
//             <h6 className="text-danger">Your Cart is Empty</h6>
//             <small className="text-muted">(Please add some products to proceed)</small>
//             <Link to="/product" className="btn btn-outline-primary btn-sm mt-3">
//               Shop Now
//             </Link>
//           </div>
//         ) : (
//           <>
//             <div className="d-flex align-items-center gap-2 mb-3">
//               <IconButton onClick={() => navigate(-1)} size="small">
//                 <ArrowBackIcon />
//               </IconButton>
//               <h4 className="mb-0">Your Cart</h4>
//             </div>

//             <div className="row">
//               <div className="col-12 col-md-8 mb-3 mb-md-0">
//                 <div className="cart-scroll-wrapper">
//                   {cartItems.map((item, index) => {
//                     const price = getPrice(item);
//                     const originalPrice = getOriginalPrice(item);
//                     const gstPercent = getGstPercent(item);
//                     const gstAmount = (price * item.quantity * gstPercent) / 100;
//                     const totalWithGst = (price * item.quantity + gstAmount).toFixed(2);
//                     const discountPercent =
//                       originalPrice > price ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0;

//                     return (
//                       <div key={index} className="cart-item-card mb-3">
//                         <div className="card-body p-3">
//                           <div className="row align-items-center">
//                             {/* Product Image */}
//                             <div className="col-12 col-md-2 mb-2 mb-md-0">
//                               <img
//                                 src={`${base_url}${item?.ProductId?.images?.[0]?.url}`}
//                                 className="img-fluid rounded"
//                                 style={{
//                                   width: "80px",
//                                   height: "80px",
//                                   objectFit: "cover",
//                                   border: '1px solid #e0e0e0',
//                                 }}
//                                 alt={item?.ProductId?.title || "Product"}
//                               />
//                             </div>

//                             {/* Product Details */}
//                             <div className="col-12 col-md-5 mb-2 mb-md-0">
//                               <div className="product-info">
//                                 <h6 className="product-title mb-1">
//                                   {item?.ProductId?.title || "Unknown Product"}
//                                 </h6>
//                                 <div className="product-price mb-1">
//                                   <strong className="text-dark">
//                                     ₹{price.toLocaleString('en-IN')}
//                                   </strong>
//                                   {originalPrice > price && (
//                                     <>
//                                       <small className="text-muted ms-2" style={{ textDecoration: 'line-through' }}>
//                                         ₹{originalPrice.toLocaleString('en-IN')}
//                                       </small>
//                                       <small className="text-success ms-2">
//                                         {discountPercent}% off
//                                       </small>
//                                     </>
//                                   )}
//                                 </div>
//                                 <small className="text-muted">
//                                   GST: {gstPercent}% (₹{gstAmount.toLocaleString('en-IN')})
//                                 </small>
//                               </div>
//                             </div>

//                             {/* Quantity Controls */}
//                             <div className="col-12 col-md-3 mb-2 mb-md-0">
//                               <div className="quantity-controls d-flex align-items-center">
//                                 <IconButton
//                                   onClick={() => decreaseQuantity(item.ProductId._id)}
//                                   disabled={item.quantity <= 1}
//                                   size="small"
//                                   className="quantity-btn"
//                                 >
//                                   <RemoveIcon fontSize="small" />
//                                 </IconButton>
//                                 <input
//                                   type="number"
//                                   className="form-control quantity-input text-center mx-1"
//                                   min={1}
//                                   max={10}
//                                   value={item?.quantity || 1}
//                                   readOnly
//                                   style={{ width: "50px", height: "32px", fontSize: '14px' }}
//                                 />
//                                 <IconButton
//                                   onClick={() => increaseQuantity(item.ProductId._id)}
//                                   size="small"
//                                   className="quantity-btn"
//                                 >
//                                   <AddIcon fontSize="small" />
//                                 </IconButton>
//                               </div>
//                             </div>

//                             {/* Subtotal and Remove Button */}
//                             <div className="col-12 col-md-2 d-flex align-items-center justify-content-between">
//                               <div className="subtotal">
//                                 <strong className="text-primary fs-6">₹{totalWithGst}</strong>
//                               </div>
//                               <IconButton
//                                 onClick={() => handleRemoveItem(item._id)}
//                                 className="remove-btn"
//                                 size="small"
//                               >
//                                 <MdDelete style={{ fontSize: "18px", color: "#ff6b6b" }} />
//                               </IconButton>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* Summary */}
//               <div className="col-12 col-md-4">
//                 <div className="cart-summary-card position-sticky" style={{ top: "80px" }}>
//                   <div className="card-body p-3">
//                     <h5 className="card-title mb-3 text-start fw-bold">PRICE DETAILS</h5>

//                     <div className="price-detail-item">
//                       <div className="d-flex justify-content-between">
//                         <span className="text-muted">Original Price ({cartItems.length} item{cartItems.length > 1 ? 's' : ''})</span>
//                         <span>₹{parseFloat(calculateOriginalTotal()).toLocaleString('en-IN')}</span>
//                       </div>
//                     </div>

//                     <div className="price-detail-item">
//                       <div className="d-flex justify-content-between">
//                         <span className="text-muted">Discount</span>
//                         <span className="text-success fw-bold">
//                           -₹{parseFloat(calculateDiscount()).toLocaleString('en-IN')}
//                         </span>
//                       </div>
//                     </div>

//                     <div className="price-detail-item">
//                       <div className="d-flex justify-content-between">
//                         <span className="text-muted">Subtotal (excl. GST)</span>
//                         <span>₹{parseFloat(calculateCartTotal()).toLocaleString('en-IN')}</span>
//                       </div>
//                     </div>

//                     <div className="price-detail-item">
//                       <div className="d-flex justify-content-between">
//                         <span className="text-muted">GST</span>
//                         <span>
//                           ₹{(parseFloat(calculateSubTotal()) - parseFloat(calculateCartTotal())).toLocaleString('en-IN')}
//                         </span>
//                       </div>
//                     </div>

//                     {/* <div className="price-detail-item">
//                       <div className="d-flex justify-content-between">
//                         <span className="text-muted">Platform Fee</span>
//                         <span>₹{platformFee.toLocaleString('en-IN')}</span>
//                       </div>
//                     </div> */}

//                     <hr className="my-1" />

//                     <div className="price-detail-item">
//                       <div className="d-flex justify-content-between align-items-center">
//                         <strong className="fs-5">Total Amount</strong>
//                         <strong className="fs-5 text-primary">
//                           ₹{(parseFloat(calculateSubTotal()) ).toLocaleString('en-IN')}
//                         </strong>
//                       </div>
//                     </div>

//                     <div className="alert alert-success mb-2 py-2" style={{ fontSize: '14px' }}>
//                       <i className="fas fa-gift me-1"></i>
//                       You will save ₹{parseFloat(calculateDiscount()).toLocaleString('en-IN')} on this order
//                     </div>

//                     <Link
//                       to="/checkout"
//                       onClick={() => localStorage.setItem("checkoutTotal", parseFloat(calculateSubTotal()) )}
//                       className="btn btn-primary w-100 mt-2 d-flex align-items-center justify-content-center gap-2 py-2"
//                     >
//                       <IoBagCheckSharp />
//                       Checkout
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="d-flex justify-content-center mt-3">
//               <a href="/product" className="btn btn-outline-primary btn-sm">
//                 Continue Shopping <span className='px-1'><LuShoppingCart /></span>
//               </a>
//             </div>
//           </>
//         )}
//       </div>

//       <style jsx>{`
//         .cart-wrapper {
//           padding: 16px 8px;
//         }

//         .cart-item-card {
//           border: 1px solid #e0e0e0 !important;
//           border-radius: 8px !important;
//           transition: box-shadow 0.2s ease;
//           background: #fff;
//         }

//         .cart-item-card:hover {
//           box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
//           border-color: #2874f0 !important;
//         }

//         .cart-summary-card {
//           border: 1px solid #e0e0e0 !important;
//           border-radius: 8px !important;
//           background: #fff;
//         }

//         .quantity-btn {
//           background-color: #fff !important;
//           border: 1px solid #ddd !important;
//           border-radius: 4px !important;
//           color: #333 !important;
//           width: 36px !important;
//           height: 36px !important;
//           padding: 0 !important;
//         }

//         .quantity-btn:hover {
//           background-color: #f8f9fa !important;
//           border-color: #2874f0 !important;
//         }

//         .quantity-btn:disabled {
//           background-color: #f5f5f5 !important;
//           color: #999 !important;
//           border-color: #ddd !important;
//         }

//         .quantity-input {
//           border: 1px solid #ddd !important;
//           border-radius: 4px !important;
//           height: 36px !important;
//           font-size: 14px !important;
//         }

//         .remove-btn {
//           background-color: #fff !important;
//           border: 1px solid #ddd !important;
//           border-radius: 4px !important;
//           padding: 6px !important;
//         }

//         .remove-btn:hover {
//           border-color: #ff6b6b !important;
//           background-color: #fff6f6 !important;
//         }

//         .product-title {
//           color: #333 !important;
//           line-height: 1.4;
//           display: -webkit-box;
//           -webkit-line-clamp: 2;
//           -webkit-box-orient: vertical;
//           overflow: hidden;
//           font-size: 15px !important;
//         }

//         .product-price {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           flex-wrap: wrap;
//         }

//         .price-detail-item {
//           padding: 8px 0;
//           font-size: 14px;
//         }

//         .subtotal {
//           min-width: 80px;
//         }

//         .cart-scroll-wrapper {
//           max-height: 60vh;
//           overflow-y: auto;
//           border: 1px solid #e0e0e0;
//           border-radius: 8px;
//           background: #fff;
//           padding: 12px;
//         }

//         .btn-primary {
//           background-color: #2874f0 !important;
//           border-color: #2874f0 !important;
//           font-weight: 600 !important;
//           border-radius: 4px !important;
//           padding: 10px 16px !important;
//           font-size: 15px !important;
//         }

//         .btn-primary:hover {
//           background-color: #1a5dc7 !important;
//           border-color: #1a5dc7 !important;
//         }

//         .btn-outline-primary {
//           border-color: #2874f0 !important;
//           color: #2874f0 !important;
//           font-weight: 600 !important;
//           padding: 8px 16px !important;
//           font-size: 14px !important;
//         }

//         .btn-outline-primary:hover {
//           background-color: #2874f0 !important;
//           color: #fff !important;
//         }

//         @media (max-width: 768px) {
//           .cart-wrapper {
//             padding: 12px 4px;
//           }

//           .cart-scroll-wrapper {
//             max-height: 50vh;
//             padding: 8px;
//           }

//           .cart-item-card {
//             padding: 8px !important;
//           }

//           .product-title {
//             font-size: 14px !important;
//             -webkit-line-clamp: 1;
//           }

//           .product-price {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 4px;
//           }

//           .quantity-controls {
//             justify-content: flex-start !important;
//             gap: 4px;
//           }

//           .quantity-input {
//             width: 48px !important;
//             font-size: 13px !important;
//           }

//           .quantity-btn {
//             width: 32px !important;
//             height: 32px !important;
//           }

//           .subtotal {
//             margin-right: 8px;
//           }

//           .cart-summary-card {
//             margin-top: 16px;
//           }

//           .price-detail-item {
//             font-size: 13px;
//           }

//           .btn-primary,
//           .btn-outline-primary {
//             font-size: 13px !important;
//             padding: 8px 12px !important;
//           }
//         }

//         @media (max-width: 576px) {
//           .cart-item-card .row {
//             flex-direction: column;
//             align-items: flex-start !important;
//           }

//           .cart-item-card .col-12 {
//             width: 100% !important;
//           }

//           .cart-scroll-wrapper {
//             max-height: 45vh;
//           }

//           .product-info {
//             margin-bottom: 8px;
//           }

//           .subtotal {
//             margin-bottom: 8px;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default Cart;

import React, { useEffect, useState } from 'react';
import emptyCartImg from "../images/EmptyCart.png";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { IoBagCheckSharp } from "react-icons/io5";
import { useDispatch, useSelector } from 'react-redux';
import { getUserCart, syncLocalCart } from '../features/user/userSlice';
import { base_url } from '../utils/axiosConfig';
import axios from 'axios';
import { IconButton, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LuShoppingCart } from "react-icons/lu";
import toast, { Toaster } from 'react-hot-toast';

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { cartProducts, isAuthenticated } = useSelector(state => state.auth);
  const [cartItems, setCartItems] = useState([]);
  const [couponCode, setCouponCode] = useState('');
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState('');

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getUserCart());
    } else {
      const savedCart = JSON.parse(localStorage.getItem('cart')) || [];
      setCartItems(savedCart);
      dispatch(syncLocalCart(savedCart));
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && cartProducts?.length > 0) {
      const updatedCart = cartProducts.map(item => ({
        ...item,
        quantity: item.quantity || 1,
      }));
      setCartItems(updatedCart);
    } else {
      const savedCart = JSON.parse(localStorage.getItem('cart')) || [];
      const updatedSavedCart = savedCart.map(item => ({
        ...item,
        quantity: item.quantity || 1,
      }));
      setCartItems(updatedSavedCart);
    }
  }, [cartProducts, isAuthenticated]);

  const getPrice = (item) => {
    const product = item?.ProductId;
    if (!product) return 0;

    if (!isAuthenticated) {
      return product.offerPrice && product.offerPrice > 0
        ? product.offerPrice
        : product.originalPrice || item.price || 0;
    }

    return product.offerPrice && product.offerPrice > 0
      ? product.offerPrice
      : product.CurrentPrice || 0;
  };

  const getOriginalPrice = (item) => {
    const product = item?.ProductId;
    if (!product) return 0;

    if (!isAuthenticated) {
      return product.originalPrice || item.price || 0;
    }

    return product.CurrentPrice || product.offerPrice || 0;
  };

  const getGstPercent = (item) => {
    const product = item?.ProductId;
    if (!product) return 0;

    return parseFloat(product.gst || '0');
  };

  const increaseQuantity = async (cartItemId) => {
    const cartItem = cartItems.find(item => item.ProductId._id === cartItemId);
    if (!cartItem) return;

    const newQuantity = cartItem.quantity + 1;

    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

        await axios.put(`${base_url}user/updatecart`, {
          ProductId: cartItemId,
          quantity: newQuantity,
          price: getPrice(cartItem),
        }, config);

        const updatedCart = cartItems.map(item =>
          item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
        );
        setCartItems(updatedCart);
        toast.success('Quantity increased!');
        dispatch(getUserCart());
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to increase quantity.');
      }
    } else {
      const updatedCart = cartItems.map(item =>
        item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
      );
      setCartItems(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      dispatch(syncLocalCart(updatedCart));
      toast.success('Quantity increased (local)!');
    }
  };

  const decreaseQuantity = async (cartItemId) => {
    const cartItem = cartItems.find(item => item.ProductId._id === cartItemId);
    if (!cartItem) return;

    const newQuantity = Math.max(1, cartItem.quantity - 1);

    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

        await axios.put(`${base_url}user/updatecart`, {
          ProductId: cartItemId,
          quantity: newQuantity,
          price: getPrice(cartItem),
        }, config);

        const updatedCart = cartItems.map(item =>
          item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
        );
        setCartItems(updatedCart);
        toast.success('Quantity decreased!');
        dispatch(getUserCart());
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to decrease quantity.');
      }
    } else {
      const updatedCart = cartItems.map(item =>
        item.ProductId._id === cartItemId ? { ...item, quantity: newQuantity } : item
      );
      setCartItems(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      dispatch(syncLocalCart(updatedCart));
      toast.success('Quantity decreased (local)!');
    }
  };

  const handleRemoveItem = async (cartItemId) => {
    if (isAuthenticated) {
      try {
        const token = JSON.parse(localStorage.getItem('customer'))?.token;
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

        await axios.delete(`${base_url}user/delete-product-cart`, {
          ...config,
          data: { cartItemId },
        });

        const updatedCart = cartItems.filter(item => item._id !== cartItemId);
        setCartItems(updatedCart);
        toast.success('Item removed!');
        dispatch(getUserCart());
      } catch (error) {
        toast.error('Error removing item.');
      }
    } else {
      const updatedCart = cartItems.filter(item => item._id !== cartItemId);
      setCartItems(updatedCart);
      localStorage.setItem('cart', JSON.stringify(updatedCart));
      dispatch(syncLocalCart(updatedCart));
      toast.success('Item removed from local cart!');
    }
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
    setCouponCode('');
    setCouponError('');
    toast.success('Coupon removed!');
  };

  const applyCoupon = async () => {
    if (!couponCode) return toast.error("Please enter a coupon code");
    if (cartItems.length === 0) return toast.error("Cart is empty");

    try {
      const response = await axios.get(`${base_url}master/getpromocode`);
      const coupons = response.data.data;

      const coupon = coupons.find(c => c.promoCodeName.toLowerCase() === couponCode.toLowerCase());
      if (!coupon) return toast.error("Invalid coupon code");

      // Check expiry date
      const today = new Date();
      const validUntil = new Date(coupon.validate);
      if (today > validUntil) return toast.error("Coupon expired");

      const cartTotal = parseFloat(calculateCartTotal());
      const discountPercent = parseFloat(coupon.offer.replace('%', ''));
      const discountAmount = ((cartTotal * discountPercent) / 100).toFixed(2);

      setAppliedCoupon(coupon);
      setCouponError('');
      toast.success(`Coupon applied! You saved ₹${discountAmount} (${discountPercent}%)`);
    } catch (error) {
      console.error(error);
      toast.error("Failed to apply coupon");
    }
  };

  const calculateCartTotal = () => {
    return cartItems
      .reduce((acc, item) => {
        const price = getPrice(item);
        return acc + price * item.quantity;
      }, 0)
      .toFixed(2);
  };

  const calculateSubTotal = () => {
    return cartItems
      .reduce((acc, item) => {
        const price = getPrice(item);
        const gstPercent = getGstPercent(item);
        const gstAmount = (price * item.quantity * gstPercent) / 100;
        return acc + price * item.quantity + gstAmount;
      }, 0)
      .toFixed(2);
  };

  const calculateOriginalTotal = () => {
    return cartItems
      .reduce((acc, item) => {
        const origPrice = getOriginalPrice(item);
        return acc + origPrice * item.quantity;
      }, 0)
      .toFixed(2);
  };

  const calculateDiscount = () => {
    const origTotal = parseFloat(calculateOriginalTotal());
    const cartTotal = parseFloat(calculateCartTotal());
    return (origTotal - cartTotal).toFixed(2);
  };

  const calculateCouponDiscount = () => {
    if (!appliedCoupon) return 0;
    const cartTotal = parseFloat(calculateCartTotal());
    const discountPercent = parseFloat(appliedCoupon.offer) || 0;
    return ((cartTotal * discountPercent) / 100).toFixed(2);
  };

  const calculateTotalWithCoupon = () => {
    const subTotal = parseFloat(calculateSubTotal());
    const couponDiscount = parseFloat(calculateCouponDiscount());
    return (subTotal - couponDiscount).toFixed(2);
  };

  const calculateSavings = () => {
    const origTotal = parseFloat(calculateOriginalTotal());
    const subtotal = parseFloat(calculateSubTotal());
    const discount = parseFloat(calculateDiscount());
    const couponDiscount = parseFloat(calculateCouponDiscount());
    return (origTotal - subtotal + discount + couponDiscount).toFixed(2);
  };

  return (
    <section className="cart-wrapper py-4">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="container-xxl px-3">
        {cartItems.length === 0 ? (
          <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '75vh' }}>
            <img
              src={emptyCartImg}
              alt="Empty Cart"
              style={{ width: '120px', height: '120px', objectFit: 'contain', marginBottom: '16px' }}
            />
            <h6 className="text-danger">Your Cart is Empty</h6>
            <small className="text-muted">(Please add some products to proceed)</small>
            <Link to="/product" className="btn btn-outline-primary btn-sm mt-3">
              Shop Now
            </Link>
          </div>
        ) : (
          <>
            <div className="d-flex align-items-center gap-2 mb-3">
              <IconButton onClick={() => navigate(-1)} size="small">
                <ArrowBackIcon />
              </IconButton>
              <h4 className="mb-0">Your Cart</h4>
            </div>

            <div className="row">
              <div className="col-12 col-md-8 mb-3 mb-md-0">
                <div className="cart-scroll-wrapper">
                  {cartItems.map((item, index) => {
                    const price = getPrice(item);
                    const originalPrice = getOriginalPrice(item);
                    const gstPercent = getGstPercent(item);
                    const gstAmount = (price * item.quantity * gstPercent) / 100;
                    const totalWithGst = (price * item.quantity + gstAmount).toFixed(2);
                    const discountPercent =
                      originalPrice > price ? Math.round(((originalPrice - price) / originalPrice) * 100) : 0;

                    return (
                      <div key={index} className="cart-item-card mb-3">
                        <div className="card-body p-3">
                          <div className="row align-items-center">
                            {/* Product Image */}
                            <div className="col-12 col-md-2 mb-2 mb-md-0">
                              <img
                                src={`${base_url}${item?.ProductId?.images?.[0]?.url}`}
                                className="img-fluid rounded"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                  objectFit: "cover",
                                  border: '1px solid #e0e0e0',
                                }}
                                alt={item?.ProductId?.title || "Product"}
                              />
                            </div>

                            {/* Product Details */}
                            <div className="col-12 col-md-5 mb-2 mb-md-0">
                              <div className="product-info">
                                <h6 className="product-title mb-1">
                                  {item?.ProductId?.title || "Unknown Product"}
                                </h6>
                                <div className="product-price mb-1">
                                  <strong className="text-dark">
                                    ₹{price.toLocaleString('en-IN')}
                                  </strong>
                                  {originalPrice > price && (
                                    <>
                                      <small className="text-muted ms-2" style={{ textDecoration: 'line-through' }}>
                                        ₹{originalPrice.toLocaleString('en-IN')}
                                      </small>
                                      <small className="text-success ms-2">
                                        {discountPercent}% off
                                      </small>
                                    </>
                                  )}
                                </div>
                                <small className="text-muted">
                                  GST: {gstPercent}% (₹{gstAmount.toLocaleString('en-IN')})
                                </small>
                              </div>
                            </div>

                            {/* Quantity Controls */}
                            <div className="col-12 col-md-3 mb-2 mb-md-0">
                              <div className="quantity-controls d-flex align-items-center">
                                <IconButton
                                  onClick={() => decreaseQuantity(item.ProductId._id)}
                                  disabled={item.quantity <= 1}
                                  size="small"
                                  className="quantity-btn"
                                >
                                  <RemoveIcon fontSize="small" />
                                </IconButton>
                                <input
                                  type="number"
                                  className="form-control quantity-input text-center mx-1"
                                  min={1}
                                  max={10}
                                  value={item?.quantity || 1}
                                  readOnly
                                  style={{ width: "50px", height: "32px", fontSize: '14px' }}
                                />
                                <IconButton
                                  onClick={() => increaseQuantity(item.ProductId._id)}
                                  size="small"
                                  className="quantity-btn"
                                >
                                  <AddIcon fontSize="small" />
                                </IconButton>
                              </div>
                            </div>

                            {/* Subtotal and Remove Button */}
                            <div className="col-12 col-md-2 d-flex align-items-center justify-content-between">
                              <div className="subtotal">
                                <strong className="text-primary fs-6">₹{totalWithGst}</strong>
                              </div>
                              <IconButton
                                onClick={() => handleRemoveItem(item._id)}
                                className="remove-btn"
                                size="small"
                              >
                                <MdDelete style={{ fontSize: "18px", color: "#ff6b6b" }} />
                              </IconButton>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Summary */}
              <div className="col-12 col-md-4">
                <div className="cart-summary-card position-sticky" style={{ top: "80px" }}>
                  <div className="card-body p-3">
                    <h5 className="card-title mb-3 text-start fw-bold">PRICE DETAILS</h5>

                    {/* Coupon Input */}
                    <div className="mb-3">
                      <div className="d-flex gap-2">
                        <TextField
                          label="Enter Coupon Code"
                          variant="outlined"
                          size="small"
                          value={couponCode}
                          onChange={(e) => {
                            setCouponCode(e.target.value);
                            setCouponError('');
                          }}
                          fullWidth
                          error={!!couponError}
                          helperText={couponError}
                          disabled={!!appliedCoupon} // Disable input when coupon is applied
                        />
                        {appliedCoupon ? (
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={removeCoupon}
                          >
                            Remove
                          </button>
                        ) : (
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={applyCoupon}
                            disabled={!couponCode}
                          >
                            Apply
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="price-detail-item">
                      <div className="d-flex justify-content-between">
                        <span className="text-muted">Original Price ({cartItems.length} item{cartItems.length > 1 ? 's' : ''})</span>
                        <span>₹{parseFloat(calculateOriginalTotal()).toLocaleString('en-IN')}</span>
                      </div>
                    </div>

                    <div className="price-detail-item">
                      <div className="d-flex justify-content-between">
                        <span className="text-muted">Discount</span>
                        <span className="text-success fw-bold">
                          -₹{parseFloat(calculateDiscount()).toLocaleString('en-IN')}
                        </span>
                      </div>
                    </div>

                    <div className="price-detail-item">
                      <div className="d-flex justify-content-between">
                        <span className="text-muted">Subtotal (excl. GST)</span>
                        <span>₹{parseFloat(calculateCartTotal()).toLocaleString('en-IN')}</span>
                      </div>
                    </div>

                    <div className="price-detail-item">
                      <div className="d-flex justify-content-between">
                        <span className="text-muted">GST</span>
                        <span>
                          ₹{(parseFloat(calculateSubTotal()) - parseFloat(calculateCartTotal())).toLocaleString('en-IN')}
                        </span>
                      </div>
                    </div>

                    {appliedCoupon && (
                      <div className="price-detail-item">
                        <div className="d-flex justify-content-between">
                          <span className="text-muted">Coupon Discount ({appliedCoupon.promoCodeName} - {appliedCoupon.offer})</span>
                          <span className="text-success fw-bold">
                            -₹{parseFloat(calculateCouponDiscount()).toLocaleString('en-IN')}
                          </span>
                        </div>
                      </div>
                    )}

                    <hr className="my-1" />

                    <div className="price-detail-item">
                      <div className="d-flex justify-content-between align-items-center">
                        <strong className="fs-5">Total Amount</strong>
                        <strong className="fs-5 text-primary">
                          ₹{parseFloat(calculateTotalWithCoupon()).toLocaleString('en-IN')}
                        </strong>
                      </div>
                    </div>

                    <div className="alert alert-success mb-2 py-2" style={{ fontSize: '14px' }}>
                      <i className="fas fa-gift me-1"></i>
                      You will save ₹{parseFloat(calculateSavings()).toLocaleString('en-IN')} on this order
                    </div>

                    <Link
                      to="/checkout"
                      onClick={() => localStorage.setItem("checkoutTotal", parseFloat(calculateTotalWithCoupon()))}
                      className="btn btn-primary w-100 mt-2 d-flex align-items-center justify-content-center gap-2 py-2"
                    >
                      <IoBagCheckSharp />
                      Checkout
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-center mt-3">
              <a href="/product" className="btn btn-outline-primary btn-sm">
                Continue Shopping <span className='px-1'><LuShoppingCart /></span>
              </a>
            </div>
          </>
        )}
      </div>

      <style jsx>{`
        .cart-wrapper {
          padding: 16px 8px;
        }

        .cart-item-card {
          border: 1px solid #e0e0e0 !important;
          border-radius: 8px !important;
          transition: box-shadow 0.2s ease;
          background: #fff;
        }

        .cart-item-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
          border-color: #2874f0 !important;
        }

        .cart-summary-card {
          border: 1px solid #e0e0e0 !important;
          border-radius: 8px !important;
          background: #fff;
        }

        .quantity-btn {
          background-color: #fff !important;
          border: 1px solid #ddd !important;
          border-radius: 4px !important;
          color: #333 !important;
          width: 36px !important;
          height: 36px !important;
          padding: 0 !important;
        }

        .quantity-btn:hover {
          background-color: #f8f9fa !important;
          border-color: #2874f0 !important;
        }

        .quantity-btn:disabled {
          background-color: #f5f5f5 !important;
          color: #999 !important;
          border-color: #ddd !important;
        }

        .quantity-input {
          border: 1px solid #ddd !important;
          border-radius: 4px !important;
          height: 36px !important;
          font-size: 14px !important;
        }

        .remove-btn {
          background-color: #fff !important;
          border: 1px solid #ddd !important;
          border-radius: 4px !important;
          padding: 6px !important;
        }

        .remove-btn:hover {
          border-color: #ff6b6b !important;
          background-color: #fff6f6 !important;
        }

        .product-title {
          color: #333 !important;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          font-size: 15px !important;
        }

        .product-price {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }

        .price-detail-item {
          padding: 8px 0;
          font-size: 14px;
        }

        .subtotal {
          min-width: 80px;
        }

        .cart-scroll-wrapper {
          
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          background: #fff;
          padding: 12px;
        }

        .btn-primary {
          background-color: #2874f0 !important;
          border-color: #2874f0 !important;
          font-weight: 600 !important;
          border-radius: 4px !important;
          padding: 10px 16px !important;
          font-size: 15px !important;
        }

        .btn-primary:hover {
          background-color: #1a5dc7 !important;
          border-color: #1a5dc7 !important;
        }

        .btn-outline-primary {
          border-color: #2874f0 !important;
          color: #2874f0 !important;
          font-weight: 600 !important;
          padding: 8px 16px !important;
          font-size: 14px !important;
        }

        .btn-outline-primary:hover {
          background-color: #2874f0 !important;
          color: #fff !important;
        }

        .btn-outline-danger {
          border-color: #ff6b6b !important;
          color: #ff6b6b !important;
          font-weight: 600 !important;
          padding: 8px 16px !important;
          font-size: 14px !important;
        }

        .btn-outline-danger:hover {
          background-color: #ff6b6b !important;
          color: #fff !important;
        }

        .btn-outline-primary:disabled,
        .btn-outline-danger:disabled {
          border-color: #ccc !important;
          color: #ccc !important;
          cursor: not-allowed;
        }

        @media (max-width: 768px) {
          .cart-wrapper {
            padding: 12px 4px;
          }

          

          .cart-item-card {
            padding: 8px !important;
          }

          .product-title {
            font-size: 14px !important;
            -webkit-line-clamp: 1;
          }

          .product-price {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;
          }

          .quantity-controls {
            justify-content: flex-start !important;
            gap: 4px;
          }

          .quantity-input {
            width: 48px !important;
            font-size: 13px !important;
          }

          .quantity-btn {
            width: 32px !important;
            height: 32px !important;
          }

          .subtotal {
            margin-right: 8px;
          }

          .cart-summary-card {
            margin-top: 16px;
          }

          .price-detail-item {
            font-size: 13px;
          }

          .btn-primary,
          .btn-outline-primary,
          .btn-outline-danger {
            font-size: 13px !important;
            padding: 8px 12px !important;
          }
        }

        @media (max-width: 576px) {
          .cart-item-card .row {
            flex-direction: column;
            align-items: flex-start !important;
          }

          .cart-item-card .col-12 {
            width: 100% !important;
          }

          

          .product-info {
            margin-bottom: 8px;
          }

          .subtotal {
            margin-bottom: 8px;
          }
        }
      `}</style>
    </section>
  );
};

export default Cart;